import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Box, Typography, Divider, Chip } from '@mui/material';
import { cartHelpers } from '../../services/ecommerceApi';

const CartOrderSummary = ({ cartTotals, totalSavings = 0, showSavings = false }) => {
  const { t } = useTranslation();
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2">{i18n.t('hardcoded.components_admin_kitform.subtotal')}</Typography>
                <Typography variant="body2">{cartHelpers.formatCurrency(cartTotals?.subtotal || 0)}</Typography>
            </Box>

            {!!cartTotals?.hasDiscount && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="success.main">{i18n.t('hardcoded.components_admin_ordermanagement.descuento')}</Typography>
                    <Typography variant="body2" color="success.main">
                        -{cartHelpers.formatCurrency(cartTotals?.discountAmount || 0)}
                    </Typography>
                </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2">{t('components_store_cartordersummary.iva_label')}</Typography>
                <Typography variant="body2">{cartHelpers.formatCurrency(cartTotals?.taxAmount || 0)}</Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2">
                    {i18n.t('hardcoded.components_store_cartordersummary.envio')}{!!cartTotals?.hasFreeShipping && <Chip label={t('components_store_cartordersummary.free_chip')} color="success" size="small" sx={{ ml: 1 }} />}
                </Typography>
                <Typography variant="body2">
                    {cartTotals?.hasFreeShipping ? t('components_store_cartordersummary.free_chip') : cartHelpers.formatCurrency(cartTotals?.shippingAmount || 0)}
                </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6" fontWeight={700}>{i18n.t('hardcoded.components_admin_ordermanagement.total')}</Typography>
                <Typography variant="h6" fontWeight={700} color="primary">
                    {cartHelpers.formatCurrency(cartTotals?.total || 0)}
                </Typography>
            </Box>

            {showSavings && totalSavings > 0 && (
                <Typography variant="body2" color="success.main" textAlign="center" mt={1.5}>
                    {t('hardcoded.components_store_cartordersummary.ahorras')}{cartHelpers.formatCurrency(totalSavings)}!
                </Typography>
            )}
        </Box>
    );
};

export default CartOrderSummary;
